import { render, staticRenderFns } from "./allStuCerfityInfo.vue?vue&type=template&id=793e47f6"
import script from "./allStuCerfityInfo.vue?vue&type=script&lang=js"
export * from "./allStuCerfityInfo.vue?vue&type=script&lang=js"
import style0 from "./allStuCerfityInfo.vue?vue&type=style&index=0&id=793e47f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports